import { useCurrentUserWithRole } from '../../../../courses/hooks';
import { removeCourseMember } from '../../../../db/courses/actions';
import { useRequestDispatch } from '../../../../utils/request-actions';

export default function useCourseTeamUserVM() {
  const requestDispatch = useRequestDispatch();
  const currentUser = useCurrentUserWithRole();

  const deleteMember = (userId: MongoId) => () => {
    return requestDispatch(removeCourseMember, {
      memberId: userId,
    });
  };

  return { currentUser, deleteMember };
}
